import React, { useEffect, useState } from 'react'
import './video.css'
import {AiFillEye} from 'react-icons/ai'
import request from '../../api'
import moment from 'moment'
import numeral from 'numeral'
import { useHistory } from 'react-router'
const Video = ({video}) => {
	console.log(video)
	const {
		id,
		snippet: {
		   channelId,
		   channelTitle,
		   title,
		   publishedAt,
		   thumbnails: { medium },
		},
		contentDetails,
	 } = video
	const [views,setViews] = useState(null)
	const [duration,setDuration] = useState(null)
	const [channelIcon,setChannelIcon] = useState(null)
	const seconds = moment.duration(duration).asSeconds()
	const _duration = moment.utc(seconds * 1000).format("mm:ss")
	
	useEffect(()=>{
		const get_video_details = async() => {
			const {data:{items}} = await request('/videos',{
				params:{
					part:'contentDetails,statistics',
					id:id
				}
			})
			setDuration(items[0].contentDetails.duration)
			setViews(items[0].statistics.viewCount)
		}
		get_video_details()
	},[id])

	useEffect(()=>{
		const get_channel_icon= async() => {
			const {data:{items}} = await request('/channels',{
				params:{
					part:'snippet',
					id:channelId
				}
			})
			
			setChannelIcon(items[0].snippet.thumbnails.default)
		}
		get_channel_icon()
	},[channelId])
	const history = useHistory()
	const handleVideoClick = () => {
		history.push(`/watch/${id}`)
	}

	return (
		<div className="video" onClick={handleVideoClick}>
			<div className="video__top">
				<img src={medium.url}/>
				<span>{_duration}</span>
			</div>
			<div className="video__title">
				{title}
			</div>
			<div className="video__details">
				<span>
					<AiFillEye />
					{numeral(views).format("0.a")} •
				</span>
				<span>{moment(publishedAt).fromNow()}</span>
			</div>
			<div className="video__channel">
				<img src={channelIcon?.url} />
				<p>{channelTitle}</p>
			</div>

		</div>
	)
}

export default Video

